// Migrated from app/assets/javascripts/common.js
// Common utilities: flash messages, iframe detection

import 'jquery'

$(function() {
   $('#flash').delay(500).slideDown('slow', function() {
      $(this).delay(5000).slideUp('normal');
   });
});

function inIframe() {
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}

window.inIframe = inIframe;
